import LocationsEdit from 'modules/Admin/locations/LocationsEdit'
import { useParams } from 'react-router-dom'
import { newDateFromString } from 'utils/date'

function LocationsEditPage() {
  const { date = '' } = useParams()
  const dateFrom = date
    ? { start: newDateFromString(date), end: newDateFromString(date) }
    : undefined

  return (
    <div data-testid="adminLocationsEditPage">
      <LocationsEdit dateFrom={dateFrom} />
    </div>
  )
}

export default LocationsEditPage
